export const navigateToTopic = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};
